import type { ChecklistItemStatus } from '../../../../components/checklist';
import { useTrackedCustomer } from './use-tracked-customer';

export function useChecklistStatus(): ChecklistItemStatus | undefined {
  const { customer, isLoading } = useTrackedCustomer();
  if (isLoading) {
    return undefined;
  }
  return customer ? 'complete' : 'pending';
}
